import { Tag } from "antd";
import { Feedback } from "@vojomo-core/shared/src/components/Feedback/Feedback";
import { useGlobal } from "../../hooks/use-global";

export const Footer = ({ style }: { style?: React.CSSProperties }) => {
  const { isMobile } = useGlobal();

  return (
    <footer
      style={{
        padding: isMobile ? "0.75rem 0" : "1rem 0",
        marginTop: "auto",
        color: "#949494",
        fontSize: isMobile ? "14px" : "16px",
        alignSelf: "center",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        userSelect: "none",
        position: "fixed",
        bottom: isMobile ? "0.5rem" : "1rem",
        left: 0,
        right: 0,
        width: "100%",
        justifyContent: "center",
        zIndex: 1000,
        ...style
      }}
    >
      <Tag
        style={{
          paddingInline: isMobile ? "8px" : "12px",
          borderRadius: "15px",
          fontSize: isMobile ? "12px" : "14px"
        }}
        color="#ef4269"
      >
        private beta
      </Tag>
      <div style={{ position: "absolute", right: isMobile ? "1rem" : "2rem" }}>
        <Feedback />
      </div>
    </footer>
  );
};
